var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Github - Original",
    clipPath: "url(#clip0_79_1039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 0.5C9.15137 0.501478 6.39601 1.51046 4.22675 3.34652C2.05749 5.18259 0.615781 7.72601 0.159422 10.522C-0.296936 13.318 0.261805 16.1842 1.73575 18.6082C3.20969 21.0321 5.50272 22.8558 8.20481 23.753C8.80093 23.8636 9.02547 23.4941 9.02547 23.18C9.02547 22.8658 9.01355 21.955 9.00957 20.9592C5.67127 21.6804 4.96586 19.5505 4.96586 19.5505C4.4214 18.1674 3.63451 17.8039 3.63451 17.8039C2.54559 17.065 3.71599 17.0788 3.71599 17.0788C4.92215 17.1637 5.55603 18.3097 5.55603 18.3097C6.62508 20.1333 8.36377 19.6058 9.04733 19.2976C9.15463 18.5251 9.46661 17.9995 9.81038 17.7012C7.14371 17.4008 4.34192 16.3774 4.34192 11.8054C4.32539 10.6197 4.7679 9.47305 5.57789 8.60268C5.45469 8.30236 5.04336 7.08923 5.69512 5.44143C5.69512 5.44143 6.70258 5.12136 8.99568 6.66444C10.9625 6.12962 13.0377 6.12962 15.0046 6.66444C17.2957 5.12136 18.3012 5.44143 18.3012 5.44143C18.9549 7.08528 18.5436 8.29841 18.4204 8.60268C19.233 9.47319 19.6764 10.6218 19.6584 11.8094C19.6584 16.3912 16.8506 17.4008 14.18 17.6952C14.6092 18.0667 14.9927 18.7918 14.9927 19.9061C14.9927 21.5026 14.9788 22.7868 14.9788 23.18C14.9788 23.4981 15.1954 23.8695 15.8034 23.753C18.5058 22.8557 20.7991 21.0317 22.273 18.6073C23.7469 16.183 24.3054 13.3163 23.8485 10.5201C23.3916 7.7238 21.9492 5.18035 19.7792 3.34461C17.6092 1.50886 14.8532 0.500541 12.0041 0.5H12.0001Z",
    fill: "#191717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.54456 17.632C4.51873 17.6913 4.42335 17.7091 4.34585 17.6676C4.26835 17.6261 4.21073 17.549 4.23855 17.4878C4.26637 17.4265 4.35976 17.4107 4.43726 17.4522C4.51476 17.4937 4.57436 17.5727 4.54456 17.632Z",
    fill: "#191717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.03123 18.1714C4.99008 18.192 4.943 18.1978 4.89805 18.1877C4.8531 18.1776 4.81308 18.1523 4.78483 18.1161C4.70734 18.0331 4.69143 17.9185 4.75104 17.8671C4.81066 17.8157 4.91797 17.8395 4.99546 17.9224C5.07296 18.0054 5.09084 18.12 5.03123 18.1714Z",
    fill: "#191717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.50437 18.857C5.43085 18.9084 5.30565 18.857 5.2361 18.7543C5.21687 18.7359 5.20158 18.7138 5.19113 18.6893C5.18068 18.6649 5.17529 18.6386 5.17529 18.612C5.17529 18.5855 5.18068 18.5592 5.19113 18.5347C5.20158 18.5103 5.21687 18.4882 5.2361 18.4698C5.30963 18.4204 5.43482 18.4698 5.50437 18.5705C5.57391 18.6713 5.5759 18.8057 5.50437 18.857Z",
    fill: "#191717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.14612 19.5209C6.08054 19.594 5.94741 19.5742 5.83812 19.4754C5.72883 19.3766 5.70299 19.2423 5.76857 19.1712C5.83414 19.1 5.96727 19.1198 6.08054 19.2166C6.1938 19.3134 6.21566 19.4497 6.14612 19.5209Z",
    fill: "#191717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M7.04617 19.9081C7.01637 20.001 6.88124 20.0425 6.74612 20.003C6.611 19.9635 6.52158 19.8528 6.54741 19.758C6.57325 19.6631 6.71036 19.6197 6.84747 19.6631C6.98457 19.7066 7.07201 19.8113 7.04617 19.9081Z",
    fill: "#191717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M8.02783 19.9753C8.02783 20.0721 7.91656 20.1551 7.77349 20.1571C7.63042 20.159 7.51318 20.08 7.51318 19.9832C7.51318 19.8864 7.62445 19.8034 7.76752 19.8014C7.91059 19.7995 8.02783 19.8765 8.02783 19.9753Z",
    fill: "#191717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M8.9419 19.8232C8.95978 19.92 8.86042 20.0207 8.71735 20.0445C8.57428 20.0682 8.4491 20.0109 8.43121 19.916C8.41333 19.8212 8.51666 19.7185 8.65576 19.6928C8.79485 19.6671 8.92401 19.7264 8.9419 19.8232Z",
    fill: "#191717"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_1039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.fa5db405797bef65e52618d88200662b.svg";
export { ForwardRef as ReactComponent };